const initState = () => {
  return [];
}

const contacts = (state=initState(), action) => {
  switch (action.type) {

    case "INIT_CONTACTS":
      const contacts = action.payload.map(i => {return {
        ...i,
        ...{avatar: `${i.avatar}?${new Date().getTime()}`}
      }});
      return contacts;

    default:
      return state;
  }
}

export default contacts;
